var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPloKoonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0pki{fill:#588443;}\r\n\t.st1pki{display:none;}\r\n\t.st2pki{fill:#825716;}\r\n\t.st3pki{fill:#D39C61;}\r\n\t.st4pki{fill:#D39C62;}\r\n\t.st5pki{fill:#BF8958;}\r\n\t.st6pki{fill:#757575;}\r\n\t.st7pki{fill:#191919;}\r\n\t.st8pki{fill:#544843;}\r\n\t.st9pki{fill:#3F3E3E;}\r\n\t.st10pki{fill:#424242;}\r\n\t.st11pki{fill:#2D2D2D;}\r\n\t.st12pki{fill:#AF7E51;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0pki",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lag_11",
    className: "st1pki"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      display: "inline",
      overflow: "visible"
    },
    width: 819,
    height: 1011,
    xlinkHref: "36C39823.jpg",
    transform: "matrix(0.2082 0 0 0.2082 -296.7769 87.2065)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2pki",
    d: "M67.7,184.8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_7"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M98.1,212.6c-2.3-2.1-4.6-4.2-6.8-6.4c3.8-8.1,7.5-16.2,11.3-24.3c-8.1-1.4-16.2-2.9-24.3-4.3 c2.5,4.4,5,8.9,7.5,13.3c-1.2,4.4-2.3,8.8-3.5,13.2c-0.3,0.9-0.9,3.2,0,6c0.7,2.4,2.2,3.8,2.9,4.4c0.6,1.1,1.9,3.3,4.6,4.9 c4,2.4,8.1,1.6,9.1,1.4C98.5,218.3,98.3,215.4,98.1,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4pki",
    d: "M261.4,126.8c-3.4-11-10.5-17.4-13.3-19.7c-2.1-5.1-4.9-11.1-8.9-17.5c-4.3-6.8-8.8-12.3-12.7-16.5 c-0.4-0.6-3.1-4.7-7.9-5.1c-4.8-0.4-9.6,2.9-11.4,8.3c-9.2-11.5-18.1-18.5-24.6-22.8c-5.2-3.4-10.2-6-19.2-12.2 c-6.4-4.5-11.4-8.4-14.7-11.1c-3.3,2.7-8.3,6.7-14.7,11.1c-9,6.2-14,8.8-19.2,12.2c-6.5,4.3-15.4,11.2-24.6,22.8 c-1.8-5.4-6.7-8.7-11.4-8.3c-4.8,0.4-7.6,4.5-7.9,5.1c-4,4.2-8.4,9.7-12.7,16.5c-4,6.4-6.8,12.4-8.9,17.5 c-2.8,2.3-9.9,8.7-13.3,19.7c-3.3,10.7-1.3,19.7-0.3,23.2c0,1.2,0.3,13.1,9.5,18.9c3,1.9,6.1,2.6,8.3,2.8c0.1,1,0.7,4.6,3.8,7 c3.6,2.7,9,2.7,13.3-0.3c7.9,3.1,15.9,6.1,23.8,9.2c0.3,1.5,1,3.7,2.5,5.7c4.4,5.7,12.6,6.1,14.9,6.4c7.4,0.7,18.9,4.8,36.9,20 c17.9-15.2,29.4-19.4,36.9-20c2.3-0.2,10.5-0.6,14.9-6.4c1.6-2,2.2-4.2,2.5-5.7c7.9-3.1,15.9-6.1,23.8-9.2c4.4,3,9.8,3.1,13.3,0.3 c3.1-2.4,3.7-6,3.8-7c2.2-0.2,5.3-0.8,8.3-2.8c9.1-5.7,9.5-17.6,9.5-18.9C262.7,146.5,264.7,137.5,261.4,126.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M209.1,210.6c2.3-2.1,4.6-4.2,6.8-6.4c-3.8-8.1-7.5-16.2-11.3-24.3c8.1-1.4,16.2-2.9,24.3-4.3 c-2.5,4.4-5,8.9-7.5,13.3c1.2,4.4,2.3,8.8,3.5,13.2c0.3,0.9,0.9,3.2,0,6c-0.7,2.4-2.2,3.8-2.9,4.4c-0.6,1.1-1.9,3.3-4.6,4.9 c-4,2.4-8.1,1.6-9.1,1.4C208.7,216.2,208.9,213.4,209.1,210.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4pki",
    d: "M133.9,41.3c-9,6.2-14,8.8-19.2,12.2c-6.5,4.3-15.4,11.2-24.6,22.8c-1.8-5.4-6.7-8.7-11.4-8.3 c-4.8,0.4-7.6,4.5-7.9,5.1c-4,4.2-8.4,9.7-12.7,16.5c-4,6.4-6.8,12.4-8.9,17.5c-2.8,2.3-9.9,8.7-13.3,19.7 c-3.3,10.7-1.3,19.7-0.3,23.2c0,1.2,0.3,13.1,9.5,18.9c3,1.9,6.1,2.6,8.3,2.8c0.1,1,0.7,4.6,3.8,7c3.6,2.7,9,2.7,13.3-0.3 c7.9,3.1,15.9,6.1,23.8,9.2c0.3,1.5,1,3.7,2.5,5.7c4.4,5.7,12.6,6.1,14.9,6.4c7.4,0.7,18.9,4.8,36.9,20V30.2 C145.3,32.9,140.3,36.9,133.9,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M261.4,126.8c-3.4-11-10.5-17.4-13.3-19.7c-2.1-5.1-4.9-11.1-8.9-17.5c-4.3-6.8-8.8-12.3-12.7-16.5 c-0.4-0.6-3.1-4.7-7.9-5.1c-4.8-0.4-9.6,2.9-11.4,8.3c-9.2-11.5-18.1-18.5-24.6-22.8c-5.2-3.4-10.2-6-19.2-12.2 c-6.4-4.5-11.4-8.4-14.7-11.1l0,0v189.4l0,0c17.9-15.2,29.4-19.4,36.9-20c2.3-0.2,10.5-0.6,14.9-6.4c1.6-2,2.2-4.2,2.5-5.7 c7.9-3.1,15.9-6.1,23.8-9.2c4.4,3,9.8,3.1,13.3,0.3c3.1-2.4,3.7-6,3.8-7c2.2-0.2,5.3-0.8,8.3-2.8c9.1-5.7,9.5-17.6,9.5-18.9 C262.7,146.5,264.7,137.5,261.4,126.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6pki",
    d: "M117.5,221c-4-0.8-7.9-1.6-11.9-2.3c-4.1-3.5-8.2-7-12.3-10.5c-0.7,0.3-2.8,1.1-4.2,3.3 c-2.1,3.2-1,6.8-0.8,7.2c5.8,3.9,11.7,7.8,17.5,11.6c4,0.1,8.1,0.3,12.1,0.4C117.8,227.5,117.7,224.2,117.5,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6pki",
    d: "M189.1,219.4c4-0.8,7.9-1.6,11.9-2.3c4.1-3.5,8.2-7,12.3-10.5c0.7,0.3,2.8,1.1,4.2,3.3c2.1,3.2,1,6.8,0.8,7.2 c-5.8,3.9-11.7,7.8-17.5,11.6c-4,0.1-8.1,0.3-12.1,0.4C188.9,225.9,189,222.6,189.1,219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7pki",
    d: "M134.3,290c-3-17.2-5.9-34.3-8.9-51.5c3-5.2,5.9-10.5,8.9-15.7c-0.2-6.5-1.2-15.7-5.1-25.8 c-2.1-5.5-4.6-10.1-7-13.8c-3.2,3.6-6.5,7.2-9.7,10.8c0.1,11.2,0.1,22.5,0.2,33.7c1.8,12.7,5.5,28.1,12.7,44.7 C128.2,278.8,131.2,284.7,134.3,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7pki",
    d: "M168.3,290c3-17.2,5.9-34.3,8.9-51.5c-3-5.2-5.9-10.5-8.9-15.7c0.2-6.5,1.2-15.7,5.1-25.8 c2.1-5.5,4.6-10.1,7-13.8c3.2,3.6,6.5,7.2,9.7,10.8c-0.1,11.2-0.1,22.5-0.2,33.7c-1.8,12.7-5.5,28.1-12.7,44.7 C174.4,278.8,171.3,284.7,168.3,290z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8pki",
    d: "M168.9,224.7c-0.4-5.9-0.4-18.9,7-32.7c4.9-9.1,11.2-15.1,15.4-18.4c0.6-0.1,4.3-0.5,6.5-3.8 c1.9-2.7,2-6.3,0.5-9.4c1.7-3.3,3.5-6.7,5.2-10c2.4-3.1,1.5-6.9-0.4-7.9c-1.5-0.8-3.9-0.2-5.6,1.6c-1.4,2-2.8,4.1-4.1,6.1 c-1,0.1-3.1,0.2-5.4-0.8c-3.8-1.8-5-5.5-5.2-6.1c-2.9-1.9-6.2-1.6-7.7,0.2c-1.2,1.4-0.9,3.3-0.8,3.8c-0.4,1.9-0.7,3.8-1.1,5.7 c-4,20.1-7.9,40.2-11.9,60.2c-0.5,4.7-1.1,9.4-1.6,14.1c0.4-0.5,1.8-2.1,4.2-2.8C166.3,223.7,168.3,224.4,168.9,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8pki",
    d: "M132.6,224.7c0.4-5.9,0.4-18.9-7-32.7c-4.9-9.1-11.2-15.1-15.4-18.4c-0.6-0.1-4.3-0.5-6.5-3.8 c-1.9-2.7-2-6.3-0.5-9.4c-1.7-3.3-3.5-6.7-5.2-10c-2.4-3.1-1.5-6.9,0.4-7.9c1.5-0.8,3.9-0.2,5.6,1.6c1.4,2,2.8,4.1,4.1,6.1 c1,0.1,3.1,0.2,5.4-0.8c3.8-1.8,5-5.5,5.2-6.1c2.9-1.9,6.2-1.6,7.7,0.2c1.2,1.4,0.9,3.3,0.8,3.8c0.4,1.9,0.7,3.8,1.1,5.7 c4,20.1,7.9,40.2,11.9,60.2c0.5,4.7,1.1,9.4,1.6,14.1c-0.4-0.5-1.8-2.1-4.2-2.8C135.2,223.7,133.2,224.4,132.6,224.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7pki",
    d: "M142.1,228.7c1.4,0.8,4.9,2.6,9.7,2.4c3.8-0.2,6.7-1.6,8.1-2.4c1.5-14.5,4.3-31,9.6-48.8 c2.1-6.9,4.3-13.4,6.7-19.5c0.4-1.1,0.7-2.6,0.5-4.3c-0.6-6-6.7-9-7.3-9.3c-1.6-0.4-5.8-1.7-8.9-5.7c-1.6-2-2.4-4.1-2.8-5.5 c-1.6-3.9-5.4-6.4-9.5-6.5c-4.3-0.1-8.2,2.5-9.9,6.5c0,1.2-0.1,3.2-1.3,5.5c-0.7,1.4-1.6,2.4-2.2,3.1c-1.6,0.6-4.1,1.7-6.3,4.1 c-4.7,4.9-4.6,11.2-4.5,12.7c2,6.1,3.9,12.3,5.8,18.6C134.9,196.5,138.9,213,142.1,228.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 153.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -70.8532 153.1131)",
    className: "st9pki",
    width: 17,
    height: 17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10pki",
    d: "M158.8,115.5c0.4-1.6,1.9-2.3,5.1-3.9c13.7-6.5,20.6-9.7,25.3-7.6c1.4,0.6,3.8,2.1,6,5.7 c0.2,0.5,0.3,0.9,0.5,1.4c2.2,7.2,1.8,14.3,0.3,20.5c-13,1.9-21.4-1.6-25.3-3.7C166.2,125.6,157.7,119.8,158.8,115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11pki",
    d: "M165.5,116.3c0.3-1,1.2-1.5,3.3-2.5c8.9-4.2,13.4-6.3,16.4-4.9c0.9,0.4,2.5,1.4,3.9,3.7 c0.1,0.3,0.2,0.6,0.3,0.9c1.4,4.7,1.2,9.3,0.2,13.3c-8.4,1.3-13.9-1.1-16.4-2.4C170.3,122.9,164.8,119.1,165.5,116.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10pki",
    d: "M138.3,115.5c-0.4-1.6-1.9-2.3-5.1-3.9c-13.7-6.5-20.6-9.7-25.3-7.6c-1.4,0.6-3.8,2.1-6,5.7 c-0.2,0.5-0.3,0.9-0.5,1.4c-2.2,7.2-1.8,14.3-0.3,20.5c13,1.9,21.4-1.6,25.3-3.7C131,125.6,139.5,119.8,138.3,115.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11pki",
    d: "M131.6,116.3c-0.3-1-1.2-1.5-3.3-2.5c-8.9-4.2-13.4-6.3-16.4-4.9c-0.9,0.4-2.5,1.4-3.9,3.7 c-0.1,0.3-0.2,0.6-0.3,0.9c-1.4,4.7-1.2,9.3-0.2,13.3c8.4,1.3,13.9-1.1,16.4-2.4C126.8,122.9,132.4,119.1,131.6,116.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M151.7,59.7c-0.3-0.2,3.2-4.2,5.5-10.8c1.5-4.2,2-7.9,2.1-10.5c1,0.7,2,1.4,3,2.1c-0.5,2.5-1.5,6-3.5,9.9 C155.8,56,152,59.9,151.7,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12pki",
    d: "M145.5,59.7c0.3-0.2-3.2-4.2-5.5-10.8c-1.5-4.2-1.9-7.9-2.1-10.5c-1,0.7-2,1.4-3,2.1c0.5,2.5,1.5,6,3.5,9.8 C141.3,56,145.2,59.9,145.5,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M154.3,86c11.9-11.1,26.8-14.1,36.4-8.3c2,1.2,5.7,4,8.3,10c-3.2-3.7-6.5-5.8-9-7 C173.8,72.9,155.8,84.9,154.3,86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M154.4,94.4c11.9-11.1,26.8-14.1,36.4-8.3c2,1.2,5.7,4,8.3,10c-3.2-3.7-6.5-5.8-9-7 C173.9,81.4,155.9,93.4,154.4,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M145.5,86c-11.9-11.1-26.8-14.1-36.4-8.3c-2,1.2-5.7,4-8.3,10c3.2-3.7,6.5-5.8,9-7 C125.9,72.9,144,84.9,145.5,86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M145.3,94.4c-11.9-11.1-26.8-14.1-36.4-8.3c-2,1.2-5.7,4-8.3,10c3.2-3.7,6.5-5.8,9-7 C125.8,81.4,143.8,93.4,145.3,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M226.9,87.4c4,6.4,10.8,19.1,12.5,36.4c2,20.3-4,36-7.2,43c2.3-9.2,4.4-22.3,3.6-37.9 C234.9,111.2,230.6,96.9,226.9,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M245.8,115.1c3.5,4.5,9.2,13.3,9.4,24.3c0.3,12.9-6.9,21.9-10.6,25.9c3-5.5,6.2-13.3,6.7-23.2 C251.8,130.9,248.7,121.5,245.8,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3pki",
    d: "M212.3,76.7c4,7.8,10.8,23.1,12.5,44.2c2,24.6-4,43.7-7.2,52.2c2.3-11.2,4.4-27.1,3.6-46 C220.3,105.5,216,88.2,212.3,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M70.5,87.4c-4,6.4-10.8,19.1-12.5,36.4c-2,20.3,4,36,7.2,43c-2.3-9.2-4.4-22.3-3.6-37.9 C62.5,111.2,66.8,96.9,70.5,87.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M51.6,115.1c-3.5,4.5-9.2,13.3-9.4,24.3c-0.3,12.9,6.9,21.9,10.6,25.9c-3-5.5-6.2-13.3-6.7-23.2 C45.6,130.9,48.8,121.5,51.6,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5pki",
    d: "M85.1,76.7c-4,7.8-10.8,23.1-12.5,44.2c-2,24.6,4,43.7,7.2,52.2c-2.3-11.2-4.4-27.1-3.6-46 C77.1,105.5,81.4,88.2,85.1,76.7z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPloKoonIcon);
export default __webpack_public_path__ + "static/media/plo-koon-icon.242b1b46.svg";
export { ForwardRef as ReactComponent };